export default __webpack_public_path__ + "static/media/forestly-expl-nn-06_DE.27decca0.png";